export { default } from './PostsSlider';
